import { useState, useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { followUser, unfollowUser, isFollowing } from '../services/followService';

export const useFollow = (targetUserId: string) => {
  const { user } = useAuth();
  const [isFollowingUser, setIsFollowingUser] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    checkFollowing();
  }, [user, targetUserId]);

  const checkFollowing = async () => {
    if (!user || user.id === targetUserId) return;
    
    const following = await isFollowing(user.id, targetUserId);
    setIsFollowingUser(following);
  };

  const toggleFollow = async () => {
    if (!user || loading || user.id === targetUserId) return;

    setLoading(true);
    try {
      if (isFollowingUser) {
        await unfollowUser(user.id, targetUserId);
        setIsFollowingUser(false);
      } else {
        await followUser(user.id, targetUserId, user.name);
        setIsFollowingUser(true);
      }
    } catch (error) {
      console.error('Error toggling follow:', error);
    } finally {
      setLoading(false);
    }
  };

  return { isFollowingUser, toggleFollow, loading };
};